<template>
  <div class="ai-page-container">
    <div
      v-if="currentLang === 'zh'"
      class="rich_media_content js_underline_content defaultNoSetting"
      id="js_content"
    >
      <div class="rich_media_area_primary_inner">
        <div class="rich_media_global_msg" id="preview_bar"></div>

        <div id="img-content" class="rich_media_wrp">
          <h3 class="h-titile">
            2026CBA中国年会，康码生物，D2P无细胞生物创新药开发智造平台，全球领先，盛大发布！
          </h3>

          <div
            class="rich_media_content js_underline_content autoTypeSetting24psection"
            id="js_content"
            style=""
          >
            <section
              powered-by="xiumi.us"
              style="
                margin-bottom: 0px;
                text-align: center;
                margin-left: 0em;
                margin-right: 0em;
                visibility: visible;
              "
              data-mpa-action-id="mnffontc169s"
            ></section>

            <section
              style="
                margin-left: 0em;
                margin-right: 0em;
                line-height: 1.6em;
                visibility: visible;
              "
              data-mpa-action-id="mnffontc3it"
            >
              <span leaf="" style="visibility: visible"
                ><br style="visibility: visible"
              /></span>
            </section>
            <section
              style="
                line-height: 1.6em;
                visibility: visible;
                margin: 20px 0 30px 0;
              "
              data-mpa-action-id="mnffontc3it"
            >
              <span leaf=""
                ><img
                  class="rich_pages wxw-img"
                  data-aistatus="1"
                  data-imgfileid="100005529"
                  data-ratio="0.575"
                  data-s="300,640"
                  data-src="https://www.healthcode.com/media/news/260509/cba-2.png"
                  data-type="png"
                  data-w="680"
                  type="block"
                  data-original-style="null"
                  data-index="5"
                  src="https://www.healthcode.com/media/news/260509/cba-2.png"
                  _width="677px"
                  style="
                    height: auto !important;
                    visibility: visible !important;
                    width: 676.968px !important;
                  "
                  alt="图片"
                  data-report-img-idx="0"
                  data-fail="0"
              /></span>
            </section>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""
                      ><span textstyle="" style="font-size: 16px"
                        >2026年5月8-10日
                        ，CBA-China中国年会在无锡国际会议中心盛大启幕。</span
                      ></span
                    ></font
                  ></span
                ></b
              ><b></b>
            </p>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><span leaf=""
                    ><span textstyle="" style="font-weight: normal"
                      >The 2026 CBA-China Annual Conference Wuxi International
                      Conference Center | May 8-10, 2026.</span
                    ></span
                  ></span
                ></b
              ><b></b>
            </p>
            <section style="text-align: center; margin-top: 40px" nodeleaf="">
              <img
                class="rich_pages wxw-img"
                data-aistatus="1"
                data-imgfileid="100005528"
                data-ratio="1.5"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-1.png"
                data-type="png"
                data-w="576"
                type="block"
                data-original-style="null"
                data-index="6"
                src="https://www.healthcode.com/media/news/260509/cba-1.png"
                _width="576px"
                style="
                  height: auto !important;
                  visibility: visible !important;
                  width: 575.995px !important;
                  margin: 0 auto;
                "
                alt="图片"
                data-report-img-idx="1"
                data-fail="0"
              />
            </section>
            <p style="line-height: 1.5em; margin-top: 30px">
              <b
                ><span
                  style="
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    margin-top: 20px;
                  "
                  ><font face="微软雅黑"
                    ><b data-pm-slice="0 0 []"
                      ><span
                        style="
                          mso-spacerun: 'yes';
                          font-family: 微软雅黑;
                          font-weight: bold;
                          font-size: 10.5pt;
                          mso-font-kerning: 1pt;
                        "
                        ><font face="微软雅黑"
                          ><span leaf=""
                            ><span textstyle="" style="font-size: 16px"
                              >大会以</span
                            ></span
                          ></font
                        ><font face="微软雅黑"
                          ><span leaf=""
                            ><span textstyle="" style="font-size: 16px"
                              >“破局共生，创健未来——应对全球变局，共筑药物创新与可及性的新生态”为主题，汇聚300+海内外权威嘉宾、4000+产业精英，精心打造13大平行论坛，覆盖早期研发、临床转化、全球注册、CGT、ADC、AI制药、投融资BD等全产业链核心赛道。</span
                            ></span
                          ></font
                        ></span
                      ></b
                    ></font
                  ></span
                ></b
              ><b></b>
            </p>
            <p
              style="line-height: 1.5em; margin-top: 20px"
              data-pm-slice="0 0 []"
            >
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><span leaf=""
                    ><span
                      textstyle=""
                      style="font-size: 16px; font-weight: normal"
                      >Under the theme "Break Barriers, Forge Synergy, Innovate
                      Health Future — Responding to Global Changes and Building
                      a New Ecosystem for Drug Innovation and Accessibility",
                      the conference will gather over 300 authoritative guests
                      at home and abroad and more than 4,000 industry elites. It
                      will feature 13 parallel forums covering core tracks
                      across the entire pharmaceutical industry chain, including
                      early-stage R&amp;D, clinical translation, global
                      registration, CGT, ADC, AI drug discovery, investment
                      &amp; financing, and business development (BD).</span
                    ></span
                  ></span
                ></b
              ><b></b>
            </p>
            <section style="text-align: center; margin: 30px 0" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005527"
                data-ratio="0.9926470588235294"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-5.png"
                data-type="png"
                data-w="680"
                type="block"
                data-original-style="null"
                data-index="7"
                src="https://www.healthcode.com/media/news/260509/cba-5.png"
                _width="677px"
                style="
                  aspect-ratio: calc(1.00741) / 1;
                  width: 677px !important;
                  height: auto !important;
                "
                alt="图片"
              />
            </section>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""
                      ><span textstyle="" style="font-size: 16px"
                        >从前沿技术解析到产业政策解读，从项目对接到资本合作，全方位呈现全球医药创新生态，为行业同仁奉上一场高规格、全维度、深干货的年度思想盛宴。</span
                      ></span
                    ></font
                  ></span
                ></b
              >
            </p>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""
                      ><span textstyle="" style="font-weight: normal"
                        >From cutting-edge technology analysis and industrial
                        policy interpretation to project matchmaking and capital
                        cooperation, the conference will present a comprehensive
                        picture of the global pharmaceutical innovation
                        ecosystem, delivering a high-standard, all-dimensional,
                        and content-rich annual intellectual feast for industry
                        peers.</span
                      ></span
                    ></font
                  ></span
                ></b
              >
            </p>
            <section
              style="text-align: center; margin: 40px 0 30px 0"
              nodeleaf=""
            >
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005530"
                data-ratio="0.6666666666666666"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-6.png"
                data-type="png"
                data-w="678"
                type="block"
                data-original-style="null"
                data-index="8"
                src="https://www.healthcode.com/media/news/260509/cba-6.png"
                _width="677px"
                style="
                  aspect-ratio: calc(1.5) / 1;
                  width: 677px !important;
                  height: auto !important;
                "
                alt="图片"
              />
            </section>
            <p
              style="line-height: 1em; margin-bottom: 0px"
              data-pm-slice="0 0 []"
            >
              <b
                ><span
                  style="
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""><br /></span></font></span
              ></b>
            </p>
            <p data-pm-slice="0 0 []">
              <b
                ><span
                  ><font face="微软雅黑"
                    ><span
                      leaf=""
                      style="
                        color: rgba(0, 0, 0, 0.9);
                        font-size: 17px;
                        font-family: 'mp-quote', 'PingFang SC', system-ui,
                          -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
                          'Hiragino Sans GB', 'Microsoft YaHei UI',
                          'Microsoft YaHei', Arial, sans-serif;
                        line-height: 1.6;
                        letter-spacing: 0.034em;
                        font-style: normal;
                        font-weight: normal;
                      "
                      ><span
                        textstyle=""
                        style="font-size: 16px; font-weight: bold"
                        >全球无细胞蛋白质合成领军企业康码生物受递参会，依托大会平台全面展示核心技术与全球化布局，斩获多项合作意向，为中国生物创新药与农业生物科技出海按下加速键！</span
                      ></span
                    ></font
                  ></span
                ></b
              ><b></b>
            </p>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><span leaf=""
                    ><span textstyle="" style="font-weight: normal"
                      >A global pioneer in cell-free protein synthesis, Comma
                      Biotech participated in the conference by invitation. It
                      exhibited core technologies and global strategic layout,
                      obtained numerous cooperation intentions, and accelerated
                      the overseas development of China’s innovative biotech and
                      agricultural biotech industry!</span
                    ></span
                  ></span
                ></b
              ><b></b>
            </p>
            <section style="text-align: center; margin: 30px 0" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005531"
                data-ratio="0.6666666666666666"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-8.png"
                data-type="png"
                data-w="678"
                type="block"
                data-original-style="null"
                data-index="9"
                src="https://www.healthcode.com/media/news/260509/cba-8.png"
                _width="677px"
                style="
                  aspect-ratio: calc(1.5) / 1;
                  width: 677px !important;
                  height: auto !important;
                "
                alt="图片"
              />
            </section>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""><br /></span></font></span></b
              ><b></b>
            </p>
            <section style="text-align: center" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005530"
                data-ratio="0.6666666666666666"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cab-18.png"
                data-type="png"
                data-w="678"
                type="block"
                data-original-style="null"
                data-index="10"
                src="https://www.healthcode.com/media/news/260509/cab-18.png"
                _width="677px"
                style="width: 677px !important; height: auto !important"
                alt="图片"
              />
            </section>
            <section
              style="margin-left: 0em; margin-right: 0em; line-height: 1.6em"
              data-mpa-action-id="mnffontc3it"
            >
              <span leaf=""><br /></span>
            </section>
            <section
              powered-by="xiumi.us"
              style="margin-bottom: 0px; margin-left: 0em; margin-right: 0em"
              data-mpa-action-id="mnffontc14ws"
            >
              <section style="font-size: 16px">
                <section style="font-size: 16px">
                  <section
                    style="
                      text-align: left;
                      margin-top: 10px;
                      margin-bottom: 0px;
                      line-height: 1.5em;
                    "
                  >
                    <section style="margin-top: 10px">
                      <section
                        style="
                          box-sizing: border-box;
                          font-style: normal;
                          font-weight: 400;
                          font-size: 16px;
                          color: rgb(62, 62, 62);
                        "
                        data-pm-slice="0 0 []"
                      >
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        ></p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 16px"
                                    >作为全球生物制造领军企业，康码深耕</span
                                  ></span
                                ></font
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 16px"
                                    >D2P无细胞蛋白质合成产业化底层技术，已累计取得三项世界第一！</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span
                                    textstyle=""
                                    style="font-size: 16px; font-weight: normal"
                                    >As a global leader in biomanufacturing,
                                    Kangma has been deeply engaged in the
                                    underlying industrialization technology of
                                    D2P cell-free protein synthesis and has
                                    accumulated three world-first
                                    achievements!</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>

                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <section
                          style="text-align: center; margin: 10px 0 20px 0"
                          nodeleaf=""
                        >
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005517"
                            data-ratio="0.27205882352941174"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-16.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="13"
                            src="https://www.healthcode.com/media/news/260509/cba-16.png"
                            _width="677px"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005517"
                            data-ratio="0.27205882352941174"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-15.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="13"
                            src="https://www.healthcode.com/media/news/260509/cba-15.png"
                            _width="677px"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span
                                    textstyle=""
                                    style="
                                      font-size: 20px;
                                      color: rgb(46, 134, 193);
                                    "
                                    >无细胞蛋白质合成领域公开专利世界第一</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span
                                    textstyle=""
                                    style="
                                      font-size: 16px;
                                      color: rgb(46, 134, 193);
                                    "
                                    >The world's number one intellectual
                                    property in the field of cell-free protein
                                    synthesis&nbsp;</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="line-height: 2em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="margin-bottom: 16px" data-pm-slice="0 0 []">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span
                                  textstyle=""
                                  style="font-size: 16px; font-weight: bold"
                                  >根据世界专利统计分析数据，在过去的</span
                                ></span
                              ></font
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span
                                  textstyle=""
                                  style="font-size: 16px; font-weight: bold"
                                  >30年间，在无细胞蛋白质合成领域，康码生物贡献公开专利排名世界第一，全球占比27%。</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="line-height: 1.5em">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span textstyle="" style="font-size: 16px"
                                  >According to the statistical analysis data of
                                  world patents, over the past 30 years, in the
                                  field of cell-free protein synthesis, Kangma
                                  Biotech has ranked first in the world in terms
                                  of publicly contributed patents, accounting
                                  for 27% of the global total.</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="line-height: 2em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005513"
                            data-ratio="0.34852941176470587"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-13.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="14"
                            src="https://www.healthcode.com/media/news/260509/cba-13.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(2.8692) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><font face="微软雅黑"
                              ><span
                                leaf=""
                                style="
                                  font-family: 微软雅黑;
                                  font-weight: bold;
                                  font-size: 10.5pt;
                                "
                                ><span
                                  textstyle=""
                                  style="
                                    font-size: 20px;
                                    color: rgb(46, 134, 193);
                                  "
                                  >无细胞蛋白质合成产品市场化世界第一</span
                                ></span
                              ></font
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><font face="微软雅黑"
                              ><span
                                leaf=""
                                style="
                                  font-family: 微软雅黑;
                                  font-weight: bold;
                                  font-size: 10.5pt;
                                "
                                ><span
                                  textstyle=""
                                  style="
                                    font-size: 16px;
                                    color: rgb(46, 134, 193);
                                  "
                                  >The world's first for commercial cell-free
                                  protein synthesis products</span
                                ></span
                              ></font
                            ></b
                          >
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="margin-bottom: 16px" data-pm-slice="0 0 []">
                          <font face="微软雅黑"
                            ><span
                              leaf=""
                              style="
                                font-family: 微软雅黑;
                                font-weight: normal;
                                font-size: 10.5pt;
                              "
                              ><span
                                textstyle=""
                                style="font-size: 16px; font-weight: bold"
                                >2022年起，康码已成功开发出30余款国内外相关机构批准的创新产品，含医疗器械、医美健康、日化防护、功能食品等，市场反馈极佳，成为无细胞蛋白质合成理论提出过去70年里，世界上第一个由此技术量产市场化产品的企业，实现了商业化闭环!</span
                              ></span
                            ></font
                          >
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span textstyle="" style="font-size: 16px"
                                  >Since 2022, Kangma Biotech has successfully
                                  developed more than 30 innovative products
                                  approved by relevant domestic and foreign
                                  institutions, including medical devices,
                                  medical aesthetics and health products, daily
                                  chemical protection products, functional
                                  foods, etc. The market feedback has been
                                  excellent. It has become the first enterprise
                                  in the world to mass-produce and market
                                  products using this technology in the 70 years
                                  since the proposal of the cell-free protein
                                  synthesis theory, achieving a commercial
                                  closed loop!</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005515"
                            data-ratio="0.27205882352941174"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-14.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="15"
                            src="https://www.healthcode.com/media/news/260509/cba-14.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(3.67568) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><font face="微软雅黑"
                              ><span
                                leaf=""
                                style="
                                  font-family: 微软雅黑;
                                  font-weight: bold;
                                  font-size: 10.5pt;
                                "
                                ><span
                                  textstyle=""
                                  style="
                                    font-size: 20px;
                                    color: rgb(46, 134, 193);
                                  "
                                  >无细胞蛋白质合成产业化规模世界第一</span
                                ></span
                              ></font
                            ></b
                          >
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><font face="微软雅黑"
                              ><span
                                leaf=""
                                style="
                                  font-family: 微软雅黑;
                                  font-weight: bold;
                                  font-size: 10.5pt;
                                "
                                ><span
                                  textstyle=""
                                  style="
                                    font-size: 16px;
                                    color: rgb(46, 134, 193);
                                  "
                                  >The world's first in industrial scale for
                                  cell-free protein synthesis
                                  industrialization</span
                                ></span
                              ></font
                            ></b
                          >
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="line-height: 1.5em"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p style="margin-bottom: 16px" data-pm-slice="0 0 []">
                          <font face="微软雅黑"
                            ><span
                              leaf=""
                              style="
                                font-family: 微软雅黑;
                                font-weight: normal;
                                font-size: 10.5pt;
                              "
                              ><span
                                textstyle=""
                                style="font-size: 16px; font-weight: bold"
                                >2023年，康码率先实现160吨级世界最大的无细胞体外合成蛋白质工厂，产业化规模是世界第二名，NASDAQ上市公司的220倍以上。</span
                              ></span
                            ></font
                          >
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span
                                  textstyle=""
                                  style="font-size: 16px; font-weight: normal"
                                  >Kangma-Healthcode has established a 160-ton
                                  protein synthesis production facility,
                                  achieving the world's largest scale for
                                  cell-free protein synthesis industrialization.
                                  Its production scale surpasses that of the
                                  second-ranked NASDAQ-listed U.S. biopharma by
                                  more than 220 times.</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p style="margin-bottom: 8px" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 20px"
                                    >[D2P无细胞蛋白合成药物开发技术智造平台]</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 16px"
                                    >D2P Cell-Free Protein Synthesis Platform
                                    for Drug Discovery &amp; Smart
                                    Biomanufacturing</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="line-height: 1.75em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005514"
                            data-ratio="1.3191176470588235"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-12.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="16"
                            src="https://www.healthcode.com/media/news/260509/cba-12.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(0.758082) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>

                        <p style="line-height: 1em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p
                          style="
                            font-weight: bold;
                            font-size: 20px;
                            margin-bottom: 10px;
                          "
                        >
                          基于全球领先的无细胞产业化技术，康码构建了下一代生物创新药研发制造的6大平台：
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span
                                    textstyle=""
                                    style="font-size: 16px; font-weight: normal"
                                    >Based on world-leading cell-free
                                    industrialization technology, Kangma has
                                    built six major platforms for the R&amp;D
                                    and manufacturing of next-generation
                                    innovative biopharmaceuticals:</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-backh="188"
                            data-backw="578"
                            data-imgfileid="100005512"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-11.png"
                            data-type="png"
                            data-w="750"
                            style="
                              aspect-ratio: calc(3.07377) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            type="block"
                            data-original-style="width:100%;"
                            data-index="17"
                            src="https://www.healthcode.com/media/news/260509/cba-11.png"
                            _width="100%"
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: center"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: center; line-height: 1.5em"
                        >
                          <span leaf=""><br /></span>
                        </p>

                        <p
                          style="
                            margin-left: 0px;
                            margin-right: 0px;
                            margin-bottom: 15px;
                          "
                          data-pm-slice="0 0 []"
                        >
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 24px"
                                    >无细胞蛋白原料药合成和优化平台</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>

                        <p
                          style="margin-left: 0px; margin-right: 0px"
                          data-pm-slice="0 0 []"
                        >
                          <span style="font-family: 微软雅黑; font-size: 10.5pt"
                            ><font face="微软雅黑"
                              ><span
                                style="
                                  font-family: 微软雅黑;
                                  font-weight: normal;
                                  font-size: 10.5pt;
                                "
                                data-pm-slice="0 0 []"
                                ><font face="微软雅黑"
                                  ><span leaf=""
                                    ><span
                                      textstyle=""
                                      style="font-size: 20px; font-weight: bold"
                                      >无细胞蛋白合成和优化平台实现高效的蛋白表达与活性优化</span
                                    ></span
                                  ></font
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p
                          style="margin-left: 0px; margin-right: 0px"
                          data-pm-slice="0 0 []"
                        >
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span
                                  style="
                                    font-family: 微软雅黑;
                                    font-size: 10.5pt;
                                  "
                                  data-pm-slice="0 0 []"
                                  ><font face="微软雅黑"
                                    ><span leaf=""
                                      ><span
                                        textstyle=""
                                        style="
                                          font-size: 16px;
                                          font-weight: normal;
                                        "
                                        >Cell-free protein synthesis and
                                        optimization platforms enable efficient
                                        protein&nbsp;</span
                                      ></span
                                    ><span
                                      style="
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                      "
                                      data-pm-slice="0 0 []"
                                      ><font face="微软雅黑"
                                        ><span leaf=""
                                          ><span
                                            textstyle=""
                                            style="
                                              font-size: 16px;
                                              font-weight: normal;
                                            "
                                            >expression and activity
                                            optimization.</span
                                          ></span
                                        ></font
                                      ></span
                                    ></font
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span
                                  style="
                                    mso-spacerun: 'yes';
                                    font-family: 微软雅黑;
                                    font-size: 10.5pt;
                                    mso-font-kerning: 1pt;
                                  "
                                  data-pm-slice="0 0 []"
                                  ><font face="微软雅黑"
                                    ><span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      data-pm-slice="0 0 []"
                                      ><span leaf=""
                                        ><br /></span></span></font></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span
                                  style="
                                    mso-spacerun: 'yes';
                                    font-family: 微软雅黑;
                                    font-size: 10.5pt;
                                    mso-font-kerning: 1pt;
                                  "
                                  data-pm-slice="0 0 []"
                                  ><font face="微软雅黑"
                                    ><span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      data-pm-slice="0 0 []"
                                      ><span leaf=""
                                        ><br /></span></span></font></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-10.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-type="png"
                            data-w="750"
                            type="block"
                            data-imgfileid="100005511"
                            data-aistatus="1"
                            data-original-style="null"
                            data-index="18"
                            src="https://www.healthcode.com/media/news/260509/cba-10.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(3.07377) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="
                            text-align: left;
                            margin-left: 0px;
                            margin-right: 0px;
                            text-indent: 0px;
                            margin-bottom: 15px;
                          "
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 24px"
                                    >基于Ai的蛋白质设计算法及分析平台</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="font-size: 20px; font-weight: bold">
                          基于AI的D2PLab算法平台赋能蛋白质结构预测与理性设计
                        </p>
                        <p
                          style="
                            margin-left: 0px;
                            margin-right: 0px;
                            text-indent: 0px;
                          "
                          data-pm-slice="0 0 []"
                        ></p>

                        <p style="" data-pm-slice="0 0 []">
                          <span
                            style="
                              mso-spacerun: 'yes';
                              font-family: 微软雅黑;
                              font-size: 10.5pt;
                              mso-font-kerning: 1pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span textstyle="" style="font-size: 16px"
                                  >AI-based D2PLab algorithm platform empowers
                                  protein structure prediction and rational
                                  design.</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <span
                            style="
                              mso-spacerun: 'yes';
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                              mso-font-kerning: 1pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""><br /></span></font
                          ></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-9.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-type="png"
                            data-w="750"
                            data-croporisrc="https://www.healthcode.com/media/news/260509/cba-9.png"
                            data-cropselx2="578"
                            data-cropsely2="188"
                            data-imgfileid="100005510"
                            data-aistatus="1"
                            data-original-style="null"
                            data-index="19"
                            src="https://www.healthcode.com/media/news/260509/cba-9.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(3.07377) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section
                          powered-by="xiumi.us"
                          style="
                            margin-bottom: 0px;
                            margin-left: 0em;
                            margin-right: 0em;
                          "
                          data-mpa-action-id="mnffontc14ws"
                        >
                          <section style="font-size: 16px">
                            <section style="font-size: 16px">
                              <section
                                style="
                                  text-align: left;
                                  margin-top: 10px;
                                  margin-bottom: 0px;
                                  line-height: 1.5em;
                                "
                              >
                                <section
                                  style="
                                    box-sizing: border-box;
                                    font-style: normal;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: rgb(62, 62, 62);
                                  "
                                  data-pm-slice='6 5 ["para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"}]'
                                >
                                  <p
                                    data-mpa-action-id="mob99ojjphs"
                                    data-pm-slice="0 0 []"
                                    style="
                                      text-align: left;
                                      margin-left: 0px;
                                      margin-right: 0px;
                                      text-indent: 0px;
                                      margin-top: 0px;
                                      margin-bottom: 15px;
                                    "
                                  >
                                    <b data-pm-slice="0 0 []"
                                      ><span
                                        style="
                                          font-family: 微软雅黑;
                                          font-weight: bold;
                                          font-size: 12pt;
                                        "
                                        ><b
                                          data-pm-slice="0 0 []"
                                          style="
                                            text-align: left;
                                            line-height: 1.5em;
                                            box-sizing: border-box;
                                            font-style: normal;
                                            color: rgb(62, 62, 62);
                                            text-indent: 0px;
                                            font-family: 微软雅黑;
                                            font-weight: bold;
                                            font-size: 12pt;
                                          "
                                          ><font face="微软雅黑"
                                            ><span leaf=""
                                              ><span
                                                textstyle=""
                                                style="font-size: 24px"
                                                >蛋白药物快速表征与质控平台</span
                                              ></span
                                            ></font
                                          ></b
                                        ></span
                                      ></b
                                    >
                                  </p>
                                  <p
                                    data-mpa-action-id="mob99ojjphs"
                                    data-pm-slice="0 0 []"
                                    style="text-align: left"
                                  >
                                    <span leaf=""
                                      ><span
                                        textstyle=""
                                        style="
                                          font-size: 20px;
                                          font-weight: bold;
                                        "
                                        >建立多维度的蛋白快速表征体系确保药物质量稳定可控</span
                                      ></span
                                    >
                                  </p>
                                  <p
                                    style="text-align: left"
                                    data-pm-slice="0 0 []"
                                  >
                                    <span
                                      style="
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""
                                          ><span
                                            textstyle=""
                                            style="font-size: 16px"
                                            >Establish a multi-dimensional rapid
                                            protein characterization system to
                                            guarantee the stable and
                                            controllable quality of
                                            pharmaceutical products.</span
                                          ></span
                                        ></font
                                      ></span
                                    >
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                  <section
                                    style="text-align: center"
                                    nodeleaf=""
                                  >
                                    <img
                                      data-src="https://www.healthcode.com/media/news/260509/cba-7.png"
                                      class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                                      data-ratio="0.3253333333333333"
                                      data-s="300,640"
                                      data-type="png"
                                      data-w="750"
                                      style="
                                        aspect-ratio: calc(3.07377) / 1;
                                        width: 677px !important;
                                        height: auto !important;
                                      "
                                      type="block"
                                      data-backw="578"
                                      data-backh="188"
                                      data-imgfileid="100005507"
                                      data-aistatus="1"
                                      data-original-style="width: 100%;"
                                      data-index="20"
                                      src="https://www.healthcode.com/media/news/260509/cba-7.png"
                                      _width="100%"
                                      alt="图片"
                                    />
                                  </section>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                  <section
                                    style="
                                      text-align: left;
                                      margin-top: 10px;
                                      margin-bottom: 0px;
                                      line-height: 1.5em;
                                    "
                                  >
                                    <section style="margin-top: 10px">
                                      <section
                                        style="
                                          box-sizing: border-box;
                                          font-style: normal;
                                          font-weight: 400;
                                          font-size: 16px;
                                          color: rgb(62, 62, 62);
                                        "
                                        data-pm-slice="0 0 []"
                                      >
                                        <section
                                          powered-by="xiumi.us"
                                          style="
                                            margin-bottom: 0px;
                                            margin-left: 0em;
                                            margin-right: 0em;
                                          "
                                          data-mpa-action-id="mnffontc14ws"
                                        >
                                          <section
                                            style="
                                              text-align: left;
                                              margin-top: 10px;
                                              margin-bottom: 0px;
                                              line-height: 1.5em;
                                            "
                                          >
                                            <section
                                              style="
                                                box-sizing: border-box;
                                                font-style: normal;
                                                font-weight: 400;
                                                font-size: 16px;
                                                color: rgb(62, 62, 62);
                                              "
                                              data-pm-slice='6 5 ["para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"box-sizing: border-box;font-style: normal;font-weight: 400;font-size: 16px;color: rgb(62, 62, 62);","data-pm-slice":"0 0 []"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"}]'
                                            >
                                              <p
                                                data-mpa-action-id="mob99ojjphs"
                                                data-pm-slice="0 0 []"
                                                style="
                                                  text-align: left;
                                                  margin-left: 0px;
                                                  margin-right: 0px;
                                                  text-indent: 0px;
                                                  margin-bottom: 15px;
                                                "
                                              >
                                                <font face="微软雅黑"
                                                  ><b data-pm-slice="0 0 []"
                                                    ><span
                                                      style="
                                                        font-family: 微软雅黑;
                                                        font-weight: bold;
                                                        font-size: 12pt;
                                                      "
                                                      ><font face="微软雅黑"
                                                        ><b
                                                          data-pm-slice="0 0 []"
                                                          style="
                                                            line-height: 1.5em;
                                                            box-sizing: border-box;
                                                            font-style: normal;
                                                            color: rgb(
                                                              62,
                                                              62,
                                                              62
                                                            );
                                                            text-align: left;
                                                            text-indent: 0px;
                                                            font-family: 微软雅黑;
                                                            font-weight: bold;
                                                            font-size: 12pt;
                                                          "
                                                          ><span leaf=""
                                                            ><span
                                                              textstyle=""
                                                              style="
                                                                font-size: 24px;
                                                              "
                                                              >大分子药物制剂开发平台</span
                                                            ></span
                                                          ></b
                                                        ></font
                                                      ></span
                                                    ></b
                                                  ></font
                                                >
                                              </p>

                                              <p
                                                style=""
                                                data-pm-slice="0 0 []"
                                              >
                                                <font face="微软雅黑"
                                                  ><span
                                                    style="
                                                      mso-spacerun: 'yes';
                                                      font-family: 微软雅黑;
                                                      font-weight: normal;
                                                      font-size: 10.5pt;
                                                      mso-font-kerning: 1pt;
                                                    "
                                                    ><font face="微软雅黑"
                                                      ><span leaf=""
                                                        ><span
                                                          textstyle=""
                                                          style="
                                                            font-size: 20px;
                                                            font-weight: bold;
                                                          "
                                                          >大分子药物制剂与透皮递送技术提升药物生物利用度</span
                                                        ></span
                                                      ></font
                                                    ></span
                                                  ></font
                                                >
                                              </p>
                                              <p
                                                style=""
                                                data-pm-slice="0 0 []"
                                              >
                                                <font face="微软雅黑"
                                                  ><span
                                                    style="
                                                      mso-spacerun: 'yes';
                                                      font-family: 微软雅黑;
                                                      font-size: 10.5pt;
                                                      mso-font-kerning: 1pt;
                                                    "
                                                    ><font face="微软雅黑"
                                                      ><span leaf=""
                                                        ><span
                                                          textstyle=""
                                                          style="
                                                            font-size: 16px;
                                                          "
                                                          >Macromolecular drug
                                                          formulation combined
                                                          with transdermal
                                                          delivery technology
                                                          improves drug
                                                          bioavailability.</span
                                                        ></span
                                                      ></font
                                                    ></span
                                                  ></font
                                                >
                                              </p>
                                              <p
                                                style="text-align: left"
                                                data-pm-slice="0 0 []"
                                              >
                                                <font face="微软雅黑"
                                                  ><span
                                                    style="
                                                      font-family: 微软雅黑;
                                                      font-size: 10.5pt;
                                                    "
                                                    ><font face="微软雅黑"
                                                      ><span leaf=""
                                                        ><br /></span></font></span
                                                ></font>
                                              </p>
                                            </section>
                                          </section>
                                        </section>
                                      </section>
                                    </section>
                                  </section>
                                  <p>
                                    <span leaf=""><br /></span>
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                </section>
                              </section>
                            </section>
                          </section>
                        </section>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-4.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-type="png"
                            data-w="750"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            data-croporisrc="https://mmecoa.qpic.cn/sz_mmecoa_png/HQa0QSLr0vI4o84BaJibB5VFtvtp81JZoxPhl1Ywcyicul8tTe5C5ibIO8onttYbU4F5d3RVJ8I6qD7fPL8LOssHjltstQibJytfBPkaMTHJtRc/0?wx_fmt=png&amp;from=appmsg"
                            data-cropselx2="578"
                            data-cropsely2="188"
                            data-imgfileid="100005520"
                            data-aistatus="1"
                            data-original-style="width: 100%;"
                            data-index="21"
                            src="https://www.healthcode.com/media/news/260509/cba-4.png"
                            _width="100%"
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section
                          style="
                            text-align: left;
                            margin-top: 10px;
                            margin-bottom: 0px;
                            line-height: 1.5em;
                          "
                        >
                          <section
                            style="
                              box-sizing: border-box;
                              font-style: normal;
                              font-weight: 400;
                              font-size: 16px;
                              color: rgb(62, 62, 62);
                            "
                            data-pm-slice='6 5 ["para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"}]'
                          >
                            <section
                              style="
                                text-align: left;
                                margin-top: 10px;
                                margin-bottom: 0px;
                                line-height: 1.5em;
                              "
                            >
                              <section style="margin-top: 10px">
                                <section
                                  style="
                                    box-sizing: border-box;
                                    font-style: normal;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: rgb(62, 62, 62);
                                  "
                                  data-pm-slice="0 0 []"
                                >
                                  <section
                                    powered-by="xiumi.us"
                                    style="
                                      margin-bottom: 0px;
                                      margin-left: 0em;
                                      margin-right: 0em;
                                    "
                                    data-mpa-action-id="mnffontc14ws"
                                  >
                                    <section
                                      style="
                                        text-align: left;
                                        margin-top: 10px;
                                        margin-bottom: 0px;
                                        line-height: 1.5em;
                                      "
                                    >
                                      <section
                                        style="
                                          box-sizing: border-box;
                                          font-style: normal;
                                          font-weight: 400;
                                          font-size: 16px;
                                          color: rgb(62, 62, 62);
                                        "
                                      >
                                        <p
                                          data-mpa-action-id="mob99ojjphs"
                                          data-pm-slice="0 0 []"
                                          style="
                                            text-align: left;
                                            margin-left: 0px;
                                            margin-right: 0px;
                                            text-indent: 0px;
                                            margin-bottom: 15px;
                                          "
                                        >
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><font face="微软雅黑"
                                                ><b
                                                  data-pm-slice="0 0 []"
                                                  style="
                                                    text-align: left;
                                                    line-height: 1.5em;
                                                    box-sizing: border-box;
                                                    font-style: normal;
                                                    color: rgb(62, 62, 62);
                                                    text-indent: 0px;
                                                    font-family: 微软雅黑;
                                                    font-weight: bold;
                                                    font-size: 12pt;
                                                  "
                                                  ><span leaf=""
                                                    ><span
                                                      textstyle=""
                                                      style="font-size: 24px"
                                                      >免疫毒素靶向药物开发平台</span
                                                    ></span
                                                  ></b
                                                ></font
                                              ></b
                                            ></b
                                          >
                                        </p>

                                        <p
                                          style="
                                            font-size: 20px;
                                            font-weight: bold;
                                          "
                                        >
                                          领先ADC一代的生物毒素药物精准靶向并清除病变细胞
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><span
                                              style="
                                                mso-spacerun: 'yes';
                                                font-family: 微软雅黑;
                                                font-size: 10.5pt;
                                                mso-font-kerning: 1pt;
                                              "
                                              ><font face="微软雅黑"
                                                ><span leaf=""
                                                  ><span
                                                    textstyle=""
                                                    style="
                                                      font-size: 16px;
                                                      font-weight: normal;
                                                    "
                                                    >Biotoxin drugs superior to
                                                    first-generation ADCs
                                                    precisely target and
                                                    eliminate pathological
                                                    cells.</span
                                                  ></span
                                                ></font
                                              ></span
                                            ></b
                                          >
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <section
                                          style="text-align: center"
                                          nodeleaf=""
                                        >
                                          <img
                                            data-src="https://mmecoa.qpic.cn/mmecoa_png/HQa0QSLr0vITFicQ05PzdRWG7Rsvs9bpfMSyZNiaSxiaRkmsU4Via3tk9icXzkTQc3IHfzn3fjNeur4DSjCbFHOIVJGRty5AKS4iaOzTfW5pl7CicA/640?wx_fmt=png&amp;from=appmsg#imgIndex=19"
                                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                                            data-ratio="0.3253333333333333"
                                            data-s="300,640"
                                            data-type="png"
                                            data-w="750"
                                            style="
                                              width: 677px !important;
                                              height: auto !important;
                                            "
                                            data-croporisrc="https://www.healthcode.com/media/news/260509/cba-3.png"
                                            data-cropselx2="578"
                                            data-cropsely2="188"
                                            data-imgfileid="100005508"
                                            data-aistatus="1"
                                            data-original-style="width: 100%;"
                                            data-index="22"
                                            src="https://www.healthcode.com/media/news/260509/cba-3.png"
                                            _width="100%"
                                            alt="图片"
                                          />
                                        </section>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <section
                                          powered-by="xiumi.us"
                                          style="
                                            margin-bottom: 0px;
                                            margin-left: 0em;
                                            margin-right: 0em;
                                          "
                                          data-mpa-action-id="mnffontc14ws"
                                        >
                                          <section style="font-size: 16px">
                                            <section style="font-size: 16px">
                                              <section
                                                style="
                                                  text-align: left;
                                                  margin-top: 10px;
                                                  margin-bottom: 0px;
                                                  line-height: 1.5em;
                                                "
                                              >
                                                <section
                                                  style="
                                                    box-sizing: border-box;
                                                    font-style: normal;
                                                    font-weight: 400;
                                                    font-size: 16px;
                                                    color: rgb(62, 62, 62);
                                                  "
                                                  data-pm-slice="0 0 []"
                                                >
                                                  <section
                                                    powered-by="xiumi.us"
                                                    style="
                                                      margin-bottom: 0px;
                                                      margin-left: 0em;
                                                      margin-right: 0em;
                                                    "
                                                    data-mpa-action-id="mnffontc14ws"
                                                  >
                                                    <section
                                                      style="
                                                        box-sizing: border-box;
                                                        font-style: normal;
                                                        font-weight: 400;
                                                        font-size: 16px;
                                                        color: rgb(62, 62, 62);
                                                      "
                                                    >
                                                      <p
                                                        data-mpa-action-id="mob99ojjphs"
                                                        data-pm-slice="0 0 []"
                                                        style="
                                                          text-align: left;
                                                          margin-left: 0px;
                                                          margin-right: 0px;
                                                          text-indent: 0px;
                                                          margin-bottom: 15px;
                                                        "
                                                      >
                                                        <b
                                                          data-pm-slice="0 0 []"
                                                          ><b
                                                            data-pm-slice="0 0 []"
                                                            ><font
                                                              face="微软雅黑"
                                                              ><span
                                                                style="
                                                                  font-family: 微软雅黑;
                                                                  font-weight: bold;
                                                                  font-size: 12pt;
                                                                "
                                                                ><b
                                                                  data-pm-slice="0 0 []"
                                                                  style="
                                                                    line-height: 1.5em;
                                                                    box-sizing: border-box;
                                                                    font-style: normal;
                                                                    color: rgb(
                                                                      62,
                                                                      62,
                                                                      62
                                                                    );
                                                                    text-align: left;
                                                                    text-indent: 0px;
                                                                    font-family: 微软雅黑;
                                                                    font-weight: bold;
                                                                    font-size: 12pt;
                                                                  "
                                                                  ><span leaf=""
                                                                    ><span
                                                                      textstyle=""
                                                                      style="
                                                                        font-size: 24px;
                                                                      "
                                                                      >多功能生物药物工程与整合平台</span
                                                                    ></span
                                                                  ></b
                                                                ></span
                                                              ></font
                                                            ></b
                                                          ></b
                                                        >
                                                      </p>

                                                      <p
                                                        style=""
                                                        data-pm-slice="0 0 []"
                                                      >
                                                        <b
                                                          data-pm-slice="0 0 []"
                                                          ><b
                                                            data-pm-slice="0 0 []"
                                                          ></b
                                                        ></b>
                                                      </p>
                                                      <p
                                                        data-mpa-action-id="mob99ojjphs"
                                                        data-pm-slice="0 0 []"
                                                        style="text-align: left"
                                                      >
                                                        <b
                                                          data-pm-slice="0 0 []"
                                                          ><b
                                                            data-pm-slice="0 0 []"
                                                          ></b
                                                        ></b>
                                                      </p>
                                                      <p
                                                        style=""
                                                        data-pm-slice="0 0 []"
                                                      >
                                                        <b
                                                          data-pm-slice="0 0 []"
                                                          ><b
                                                            data-pm-slice="0 0 []"
                                                            ><span
                                                              style="
                                                                mso-spacerun: 'yes';
                                                                font-family: 微软雅黑;
                                                                font-weight: normal;
                                                                font-size: 10.5pt;
                                                                mso-font-kerning: 1pt;
                                                              "
                                                              ><font
                                                                face="微软雅黑"
                                                                ><span leaf=""
                                                                  ><span
                                                                    textstyle=""
                                                                    style="
                                                                      font-size: 20px;
                                                                      font-weight: bold;
                                                                    "
                                                                    >多功能蛋白工程与系统整合实现复杂生物药的高效研发</span
                                                                  ></span
                                                                ></font
                                                              ></span
                                                            ></b
                                                          ></b
                                                        >
                                                      </p>
                                                      <p
                                                        style=""
                                                        data-pm-slice="0 0 []"
                                                      >
                                                        <b
                                                          data-pm-slice="0 0 []"
                                                          ><b
                                                            data-pm-slice="0 0 []"
                                                            ><span
                                                              style="
                                                                mso-spacerun: 'yes';
                                                                font-family: 微软雅黑;
                                                                font-size: 10.5pt;
                                                                mso-font-kerning: 1pt;
                                                              "
                                                              ><font
                                                                face="微软雅黑"
                                                                ><span leaf=""
                                                                  ><span
                                                                    textstyle=""
                                                                    style="
                                                                      font-size: 16px;
                                                                      font-weight: normal;
                                                                    "
                                                                    >Multifunctional
                                                                    protein
                                                                    engineering
                                                                    and
                                                                    systematic
                                                                    integration
                                                                    enable the
                                                                    efficient
                                                                    research and
                                                                    development
                                                                    of complex
                                                                    biotherapeutics.</span
                                                                  ></span
                                                                ></font
                                                              ></span
                                                            ></b
                                                          ></b
                                                        >
                                                      </p>
                                                    </section>
                                                  </section>
                                                </section>
                                              </section>
                                            </section>
                                          </section>
                                        </section>
                                        <section
                                          style="text-align: center;margin:30px auto 20px auto;"
                                          nodeleaf=""
                                        >
                                          <img
                                            data-src="https://www.healthcode.com/media/news/260509/cba-d2p.png"
                                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                                            data-ratio="1.7770034843205575"
                                            data-s="300,640"
                                            data-type="png"
                                            data-w="574"
                                            style="
                                              width: 578px !important;
                                              height: auto !important;
                                              margin: 0 auto;
                                            "
                                            type="block"
                                            data-backw="574"
                                            data-backh="1020"
                                            data-imgfileid="100005509"
                                            data-aistatus="1"
                                            data-original-style="width:578px;height:1027px;"
                                            data-index="23"
                                            src="https://www.healthcode.com/media/news/260509/cba-d2p.png"
                                            _width="578px"
                                            alt="图片"
                                          />
                                        </section>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                  
                                        <p style="text-align: center">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span leaf=""
                                                ><span
                                                  textstyle=""
                                                  style="
                                                    font-size: 20px;
                                                    font-weight: bold;
                                                  "
                                                  >康码利用全球领先的下一代生物制造技术，</span
                                                ></span
                                              ></b
                                            ></b
                                          >
                                        </p>
                                        <p style="text-align: center">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span leaf=""
                                                ><span
                                                  textstyle=""
                                                  style="
                                                    font-size: 20px;
                                                    font-weight: bold;
                                                  "
                                                  >推动全球医药颠覆性发展，用中国智造,造福全球。</span
                                                ></span
                                              ></b
                                            ></b
                                          >
                                        </p>
                                      </section>
                                    </section>
                                  </section>
                                </section>
                              </section>
                            </section>
                            <p style="line-height: 2em">
                              <b data-pm-slice="0 0 []"
                                ><span leaf=""><br /></span
                              ></b>
                            </p>
                          </section>
                        </section>

                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-17.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="1.7770034843205575"
                            data-s="300,640"
                            data-type="png"
                            data-w="574"
                            style="
                              width: 578px !important;
                              height: auto !important;
                              margin: 0 auto;
                            "
                            type="block"
                            data-backw="574"
                            data-backh="1020"
                            data-imgfileid="100005509"
                            data-aistatus="1"
                            data-original-style="width:578px;height:1027px;"
                            data-index="23"
                            src="https://www.healthcode.com/media/news/260509/cba-17.png"
                            _width="578px"
                            alt="图片"
                          />
                        </section>
                       
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
            <p style="display: none">
              <mp-style-type data-value="3"></mp-style-type>
            </p>
          </div>
        </div>


      </div>
    </div>

    <div
      v-else
      class="rich_media_content js_underline_content defaultNoSetting"
      id="js_content"
    >
      <h3 class="h-titile">
        2026 CBA China Annual Conference Kangma BiotechGlobal Leading D2P
        Cell-Free Biotech Innovative Drug Development & Intelligent
        Manufacturing Platform, Grand Launch!
      </h3>
      <div class="rich_media_area_primary_inner">
        <div class="rich_media_global_msg" id="preview_bar"></div>

        <div id="img-content" class="rich_media_wrp">
          <div
            id="js_novel_card"
            class="novel-card js_wx_tap_highlight wx_tap_card"
            style="display: none"
          >
            <div class="novel-card__left novel-card__new-only">
              <div id="js_novel_cover" class="novel-card__cover">
                <img />
              </div>
              <div class="novel-card__text">
                <div id="js_novel_title" class="novel-card__main">
                  在小说阅读器读本章
                </div>
                <div id="js_novel_subtitle" class="novel-card__subtitle"></div>
              </div>
            </div>
            <div
              id="js_novel_link"
              class="novel-card__link novel-card__new-only"
            >
              去阅读
            </div>

            <div class="novel-info novel-card__old-only">
              <div class="novel-cover-group">
                <div id="js_novel_cover_old" class="novel-cover">
                  <img />
                </div>
                <div class="novel-meta">
                  <div id="js_novel_title_old" class="novel-title"></div>
                </div>
              </div>
            </div>
            <div class="arrow-jump-icon novel-card__old-only"></div>
          </div>

          <div
            class="rich_media_content js_underline_content autoTypeSetting24psection"
            id="js_content"
            style=""
          >
            <section
              powered-by="xiumi.us"
              style="
                margin-bottom: 0px;
                text-align: center;
                margin-left: 0em;
                margin-right: 0em;
                visibility: visible;
              "
              data-mpa-action-id="mnffontc169s"
            ></section>

            <section
              style="
                margin-left: 0em;
                margin-right: 0em;
                line-height: 1.6em;
                visibility: visible;
              "
              data-mpa-action-id="mnffontc3it"
            >
              <span leaf="" style="visibility: visible"
                ><br style="visibility: visible"
              /></span>
            </section>
            <section
              style="
                line-height: 1.6em;
                visibility: visible;
                margin: 20px 0 30px 0;
              "
              data-mpa-action-id="mnffontc3it"
            >
              <span leaf=""
                ><img
                  class="rich_pages wxw-img"
                  data-aistatus="1"
                  data-imgfileid="100005529"
                  data-ratio="0.575"
                  data-s="300,640"
                  data-src="https://www.healthcode.com/media/news/260509/cba-2.png"
                  data-type="png"
                  data-w="680"
                  type="block"
                  data-original-style="null"
                  data-index="5"
                  src="https://www.healthcode.com/media/news/260509/cba-2.png"
                  _width="677px"
                  style="
                    height: auto !important;
                    visibility: visible !important;
                    width: 676.968px !important;
                  "
                  alt="图片"
                  data-report-img-idx="0"
                  data-fail="0"
              /></span>
            </section>

            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><span leaf=""
                    ><span textstyle="" style="font-weight: normal"
                      >The 2026 CBA-China Annual Conference Wuxi International
                      Conference Center | May 8-10, 2026.</span
                    ></span
                  ></span
                ></b
              ><b></b>
            </p>
            <section style="text-align: center; margin-top: 40px" nodeleaf="">
              <img
                class="rich_pages wxw-img"
                data-aistatus="1"
                data-imgfileid="100005528"
                data-ratio="1.5"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-1.png"
                data-type="png"
                data-w="576"
                type="block"
                data-original-style="null"
                data-index="6"
                src="https://www.healthcode.com/media/news/260509/cba-1.png"
                _width="576px"
                style="
                  height: auto !important;
                  visibility: visible !important;
                  width: 575.995px !important;
                  margin: 0 auto;
                "
                alt="图片"
                data-report-img-idx="1"
                data-fail="0"
              />
            </section>

            <p
              style="line-height: 1.5em; margin: 30px 0 30px 0"
              data-pm-slice="0 0 []"
            >
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><span leaf=""
                    ><span
                      textstyle=""
                      style="font-size: 16px; font-weight: normal"
                      >Under the theme "Break Barriers, Forge Synergy, Innovate
                      Health Future — Responding to Global Changes and Building
                      a New Ecosystem for Drug Innovation and Accessibility",
                      the conference will gather over 300 authoritative guests
                      at home and abroad and more than 4,000 industry elites. It
                      will feature 13 parallel forums covering core tracks
                      across the entire pharmaceutical industry chain, including
                      early-stage R&amp;D, clinical translation, global
                      registration, CGT, ADC, AI drug discovery, investment
                      &amp; financing, and business development (BD).</span
                    ></span
                  ></span
                ></b
              ><b></b>
            </p>
            <section style="text-align: center; margin: 20px 0" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005527"
                data-ratio="0.9926470588235294"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-5.png"
                data-type="png"
                data-w="680"
                type="block"
                data-original-style="null"
                data-index="7"
                src="https://www.healthcode.com/media/news/260509/cba-5.png"
                _width="677px"
                style="
                  aspect-ratio: calc(1.00741) / 1;
                  width: 677px !important;
                  height: auto !important;
                "
                alt="图片"
              />
            </section>

            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""
                      ><span textstyle="" style="font-weight: normal"
                        >From cutting-edge technology analysis and industrial
                        policy interpretation to project matchmaking and capital
                        cooperation, the conference will present a comprehensive
                        picture of the global pharmaceutical innovation
                        ecosystem, delivering a high-standard, all-dimensional,
                        and content-rich annual intellectual feast for industry
                        peers.</span
                      ></span
                    ></font
                  ></span
                ></b
              >
            </p>
            <section style="text-align: center; margin: 20px 0" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005530"
                data-ratio="0.6666666666666666"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-6.png"
                data-type="png"
                data-w="678"
                type="block"
                data-original-style="null"
                data-index="8"
                src="https://www.healthcode.com/media/news/260509/cba-6.png"
                _width="677px"
                style="
                  aspect-ratio: calc(1.5) / 1;
                  width: 677px !important;
                  height: auto !important;
                "
                alt="图片"
              />
            </section>
            <p
              style="line-height: 1em; margin-bottom: 0px"
              data-pm-slice="0 0 []"
            >
              <b
                ><span
                  style="
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""><br /></span></font></span
              ></b>
            </p>

            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><span leaf=""
                    ><span textstyle="" style="font-weight: normal"
                      >A global pioneer in cell-free protein synthesis, Comma
                      Biotech participated in the conference by invitation. It
                      exhibited core technologies and global strategic layout,
                      obtained numerous cooperation intentions, and accelerated
                      the overseas development of China’s innovative biotech and
                      agricultural biotech industry!</span
                    ></span
                  ></span
                ></b
              ><b></b>
            </p>
            <section style="text-align: center; margin: 20px 0" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005531"
                data-ratio="0.6666666666666666"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-8.png"
                data-type="png"
                data-w="678"
                type="block"
                data-original-style="null"
                data-index="9"
                src="https://www.healthcode.com/media/news/260509/cba-8.png"
                _width="677px"
                style="
                  aspect-ratio: calc(1.5) / 1;
                  width: 677px !important;
                  height: auto !important;
                "
                alt="图片"
              />
            </section>
            <p style="" data-pm-slice="0 0 []">
              <b
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: 微软雅黑;
                    font-weight: bold;
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                  ><font face="微软雅黑"
                    ><span leaf=""><br /></span></font></span></b
              ><b></b>
            </p>
            <section style="text-align: center" nodeleaf="">
              <img
                class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                data-aistatus="1"
                data-imgfileid="100005530"
                data-ratio="0.6666666666666666"
                data-s="300,640"
                data-src="https://www.healthcode.com/media/news/260509/cba-18EN.png"
                data-type="png"
                data-w="678"
                type="block"
                data-original-style="null"
                data-index="10"
                src="https://www.healthcode.com/media/news/260509/cba-18EN.png"
                _width="677px"
                style="width: 677px !important; height: auto !important"
                alt="图片"
              />
            </section>

            <section
              powered-by="xiumi.us"
              style="margin-bottom: 0px; margin-left: 0em; margin-right: 0em"
              data-mpa-action-id="mnffontc14ws"
            >
              <section style="font-size: 16px">
                <section style="font-size: 16px">
                  <section
                    style="
                      text-align: left;
                      margin-top: 10px;
                      margin-bottom: 0px;
                      line-height: 1.5em;
                    "
                  >
                    <section style="margin-top: 10px">
                      <section
                        style="
                          box-sizing: border-box;
                          font-style: normal;
                          font-weight: 400;
                          font-size: 16px;
                          color: rgb(62, 62, 62);
                        "
                        data-pm-slice="0 0 []"
                      >
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        ></p>

                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span
                                    textstyle=""
                                    style="font-size: 16px; font-weight: normal"
                                    >As a global leader in biomanufacturing,
                                    Kangma has been deeply engaged in the
                                    underlying industrialization technology of
                                    D2P cell-free protein synthesis and has
                                    accumulated three world-first
                                    achievements!</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="line-height: 2em"
                        >
                          <span leaf=""><br /></span>
                        </p>

                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005517"
                            data-ratio="0.27205882352941174"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-16.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="13"
                            src="https://www.healthcode.com/media/news/260509/cba-16.png"
                            _width="677px"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <section
                          style="text-align: center; margin-top: 30px"
                          nodeleaf=""
                        >
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005517"
                            data-ratio="0.27205882352941174"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-15.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="13"
                            src="https://www.healthcode.com/media/news/260509/cba-15.png"
                            _width="677px"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>

                        <p style="line-height: 2em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>

                        <p style="line-height: 1.5em">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span textstyle="" style="font-size: 16px"
                                  >According to the statistical analysis data of
                                  world patents, over the past 30 years, in the
                                  field of cell-free protein synthesis, Kangma
                                  Biotech has ranked first in the world in terms
                                  of publicly contributed patents, accounting
                                  for 27% of the global total.</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="line-height: 2em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005513"
                            data-ratio="0.34852941176470587"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-13.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="14"
                            src="https://www.healthcode.com/media/news/260509/cba-13.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(2.8692) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>

                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>

                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span textstyle="" style="font-size: 16px"
                                  >Since 2022, Kangma Biotech has successfully
                                  developed more than 30 innovative products
                                  approved by relevant domestic and foreign
                                  institutions, including medical devices,
                                  medical aesthetics and health products, daily
                                  chemical protection products, functional
                                  foods, etc. The market feedback has been
                                  excellent. It has become the first enterprise
                                  in the world to mass-produce and market
                                  products using this technology in the 70 years
                                  since the proposal of the cell-free protein
                                  synthesis theory, achieving a commercial
                                  closed loop!</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 10.5pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005515"
                            data-ratio="0.27205882352941174"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-14.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="15"
                            src="https://www.healthcode.com/media/news/260509/cba-14.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(3.67568) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>

                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="line-height: 1.5em"
                        >
                          <span leaf=""><br /></span>
                        </p>

                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <span
                            style="
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span
                                  textstyle=""
                                  style="font-size: 16px; font-weight: normal"
                                  >Kangma-Healthcode has established a 160-ton
                                  protein synthesis production facility,
                                  achieving the world's largest scale for
                                  cell-free protein synthesis industrialization.
                                  Its production scale surpasses that of the
                                  second-ranked NASDAQ-listed U.S. biopharma by
                                  more than 220 times.</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                        >
                          <span leaf=""><br /></span>
                        </p>

                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span textstyle="" style="font-size: 20px"
                                    >D2P Cell-Free Protein Synthesis Platform
                                    for Drug Discovery &amp; Smart
                                    Biomanufacturing</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>

                        <p style="line-height: 1.75em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-imgfileid="100005514"
                            data-ratio="1.3191176470588235"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-12.png"
                            data-type="png"
                            data-w="680"
                            type="block"
                            data-original-style="null"
                            data-index="16"
                            src="https://www.healthcode.com/media/news/260509/cba-12.png"
                            _width="677px"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 14pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>

                        <p style="line-height: 1em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="line-height: 1.5em" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""
                                  ><span
                                    textstyle=""
                                    style="font-size: 16px; font-weight: normal"
                                    >Based on world-leading cell-free
                                    industrialization technology, Kangma has
                                    built six major platforms for the R&amp;D
                                    and manufacturing of next-generation
                                    innovative biopharmaceuticals:</span
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-aistatus="1"
                            data-backh="188"
                            data-backw="578"
                            data-imgfileid="100005512"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-src="https://www.healthcode.com/media/news/260509/cba-11.png"
                            data-type="png"
                            data-w="750"
                            style="
                              aspect-ratio: calc(3.07377) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            type="block"
                            data-original-style="width:100%;"
                            data-index="17"
                            src="https://www.healthcode.com/media/news/260509/cba-11.png"
                            _width="100%"
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: center"
                        >
                          <span leaf=""><br /></span>
                        </p>

                        <p
                          style="margin-left: 0px; margin-right: 0px"
                          data-pm-slice="0 0 []"
                        >
                          <b
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span
                                  style="
                                    font-family: 微软雅黑;
                                    font-size: 10.5pt;
                                  "
                                  data-pm-slice="0 0 []"
                                  ><font face="微软雅黑"
                                    ><span leaf=""
                                      ><span
                                        textstyle=""
                                        style="
                                          font-size: 16px;
                                          font-weight: normal;
                                        "
                                        >Cell-free protein synthesis and
                                        optimization platforms enable efficient
                                        protein&nbsp;</span
                                      ></span
                                    ><span
                                      style="
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                      "
                                      data-pm-slice="0 0 []"
                                      ><font face="微软雅黑"
                                        ><span leaf=""
                                          ><span
                                            textstyle=""
                                            style="
                                              font-size: 16px;
                                              font-weight: normal;
                                            "
                                            >expression and activity
                                            optimization.</span
                                          ></span
                                        ></font
                                      ></span
                                    ></font
                                  ></span
                                ></font
                              ></span
                            ></b
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span
                                  style="
                                    mso-spacerun: 'yes';
                                    font-family: 微软雅黑;
                                    font-size: 10.5pt;
                                    mso-font-kerning: 1pt;
                                  "
                                  data-pm-slice="0 0 []"
                                  ><font face="微软雅黑"
                                    ><span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      data-pm-slice="0 0 []"
                                      ><span leaf=""
                                        ><br /></span></span></font></span></font></span
                          ></b>
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <b
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span
                                  style="
                                    mso-spacerun: 'yes';
                                    font-family: 微软雅黑;
                                    font-size: 10.5pt;
                                    mso-font-kerning: 1pt;
                                  "
                                  data-pm-slice="0 0 []"
                                  ><font face="微软雅黑"
                                    ><span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      data-pm-slice="0 0 []"
                                      ><span leaf=""
                                        ><br /></span></span></font></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-10.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-type="png"
                            data-w="750"
                            type="block"
                            data-imgfileid="100005511"
                            data-aistatus="1"
                            data-original-style="null"
                            data-index="18"
                            src="https://www.healthcode.com/media/news/260509/cba-10.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(3.07377) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <span leaf=""><br /></span>
                        </p>

                        <p style="" data-pm-slice="0 0 []">
                          <span
                            style="
                              mso-spacerun: 'yes';
                              font-family: 微软雅黑;
                              font-size: 10.5pt;
                              mso-font-kerning: 1pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""
                                ><span textstyle="" style="font-size: 16px"
                                  >AI-based D2PLab algorithm platform empowers
                                  protein structure prediction and rational
                                  design.</span
                                ></span
                              ></font
                            ></span
                          >
                        </p>
                        <p style="" data-pm-slice="0 0 []">
                          <span
                            style="
                              mso-spacerun: 'yes';
                              font-family: 微软雅黑;
                              font-weight: normal;
                              font-size: 10.5pt;
                              mso-font-kerning: 1pt;
                            "
                            ><font face="微软雅黑"
                              ><span leaf=""><br /></span></font
                          ></span>
                        </p>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-9.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-type="png"
                            data-w="750"
                            data-croporisrc="https://www.healthcode.com/media/news/260509/cba-9.png"
                            data-cropselx2="578"
                            data-cropsely2="188"
                            data-imgfileid="100005510"
                            data-aistatus="1"
                            data-original-style="null"
                            data-index="19"
                            src="https://www.healthcode.com/media/news/260509/cba-9.png"
                            _width="677px"
                            style="
                              aspect-ratio: calc(3.07377) / 1;
                              width: 677px !important;
                              height: auto !important;
                            "
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>

                        <section
                          powered-by="xiumi.us"
                          style="
                            margin-bottom: 0px;
                            margin-left: 0em;
                            margin-right: 0em;
                          "
                          data-mpa-action-id="mnffontc14ws"
                        >
                          <section style="font-size: 16px">
                            <section style="font-size: 16px">
                              <section
                                style="
                                  text-align: left;
                                  margin-top: 10px;
                                  margin-bottom: 0px;
                                  line-height: 1.5em;
                                "
                              >
                                <section
                                  style="
                                    box-sizing: border-box;
                                    font-style: normal;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: rgb(62, 62, 62);
                                  "
                                  data-pm-slice='6 5 ["para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"}]'
                                >
                                  <p
                                    style="text-align: left"
                                    data-pm-slice="0 0 []"
                                  >
                                    <span
                                      style="
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""
                                          ><span
                                            textstyle=""
                                            style="font-size: 16px"
                                            >Establish a multi-dimensional rapid
                                            protein characterization system to
                                            guarantee the stable and
                                            controllable quality of
                                            pharmaceutical products.</span
                                          ></span
                                        ></font
                                      ></span
                                    >
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                  <section
                                    style="text-align: center"
                                    nodeleaf=""
                                  >
                                    <img
                                      data-src="https://www.healthcode.com/media/news/260509/cba-7.png"
                                      class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                                      data-ratio="0.3253333333333333"
                                      data-s="300,640"
                                      data-type="png"
                                      data-w="750"
                                      style="
                                        aspect-ratio: calc(3.07377) / 1;
                                        width: 677px !important;
                                        height: auto !important;
                                      "
                                      type="block"
                                      data-backw="578"
                                      data-backh="188"
                                      data-imgfileid="100005507"
                                      data-aistatus="1"
                                      data-original-style="width: 100%;"
                                      data-index="20"
                                      src="https://www.healthcode.com/media/news/260509/cba-7.png"
                                      _width="100%"
                                      alt="图片"
                                    />
                                  </section>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>

                                  <section
                                    style="
                                      text-align: left;
                                      margin-top: 10px;
                                      margin-bottom: 0px;
                                      line-height: 1.5em;
                                    "
                                  >
                                    <section style="margin-top: 10px">
                                      <section
                                        style="
                                          box-sizing: border-box;
                                          font-style: normal;
                                          font-weight: 400;
                                          font-size: 16px;
                                          color: rgb(62, 62, 62);
                                        "
                                        data-pm-slice="0 0 []"
                                      >
                                        <section
                                          powered-by="xiumi.us"
                                          style="
                                            margin-bottom: 0px;
                                            margin-left: 0em;
                                            margin-right: 0em;
                                          "
                                          data-mpa-action-id="mnffontc14ws"
                                        >
                                          <section
                                            style="
                                              text-align: left;
                                              margin-top: 10px;
                                              margin-bottom: 0px;
                                              line-height: 1.5em;
                                            "
                                          >
                                            <section
                                              style="
                                                box-sizing: border-box;
                                                font-style: normal;
                                                font-weight: 400;
                                                font-size: 16px;
                                                color: rgb(62, 62, 62);
                                              "
                                              data-pm-slice='6 5 ["para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"box-sizing: border-box;font-style: normal;font-weight: 400;font-size: 16px;color: rgb(62, 62, 62);","data-pm-slice":"0 0 []"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"}]'
                                            >
                                              <p
                                                style=""
                                                data-pm-slice="0 0 []"
                                              >
                                                <font face="微软雅黑"
                                                  ><span
                                                    style="
                                                      mso-spacerun: 'yes';
                                                      font-family: 微软雅黑;
                                                      font-weight: normal;
                                                      font-size: 10.5pt;
                                                      mso-font-kerning: 1pt;
                                                    "
                                                    ><font face="微软雅黑"
                                                      ><span leaf=""
                                                        ><span
                                                          textstyle=""
                                                          style="
                                                            font-size: 15px;
                                                          "
                                                          >Macromolecular drug
                                                          formulation combined
                                                          with transdermal
                                                          delivery technology
                                                          improves drug
                                                          bioavailability.</span
                                                        ></span
                                                      ></font
                                                    ></span
                                                  ></font
                                                >
                                              </p>

                                              <p
                                                style="text-align: left"
                                                data-pm-slice="0 0 []"
                                              >
                                                <font face="微软雅黑"
                                                  ><span
                                                    style="
                                                      font-family: 微软雅黑;
                                                      font-size: 10.5pt;
                                                    "
                                                    ><font face="微软雅黑"
                                                      ><span leaf=""
                                                        ><br /></span></font></span
                                                ></font>
                                              </p>
                                            </section>
                                          </section>
                                        </section>
                                      </section>
                                    </section>
                                  </section>
                                  <p>
                                    <span leaf=""><br /></span>
                                  </p>
                                  <p style="" data-pm-slice="0 0 []">
                                    <span
                                      style="
                                        mso-spacerun: 'yes';
                                        font-family: 微软雅黑;
                                        font-size: 10.5pt;
                                        mso-font-kerning: 1pt;
                                      "
                                      ><font face="微软雅黑"
                                        ><span leaf=""><br /></span></font
                                    ></span>
                                  </p>
                                </section>
                              </section>
                            </section>
                          </section>
                        </section>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-4.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="0.3253333333333333"
                            data-s="300,640"
                            data-type="png"
                            data-w="750"
                            style="
                              width: 677px !important;
                              height: auto !important;
                            "
                            data-croporisrc="https://mmecoa.qpic.cn/sz_mmecoa_png/HQa0QSLr0vI4o84BaJibB5VFtvtp81JZoxPhl1Ywcyicul8tTe5C5ibIO8onttYbU4F5d3RVJ8I6qD7fPL8LOssHjltstQibJytfBPkaMTHJtRc/0?wx_fmt=png&amp;from=appmsg"
                            data-cropselx2="578"
                            data-cropsely2="188"
                            data-imgfileid="100005520"
                            data-aistatus="1"
                            data-original-style="width: 100%;"
                            data-index="21"
                            src="https://www.healthcode.com/media/news/260509/cba-4.png"
                            _width="100%"
                            alt="图片"
                          />
                        </section>
                        <p
                          data-mpa-action-id="mob99ojjphs"
                          data-pm-slice="0 0 []"
                          style="text-align: left"
                        >
                          <b data-pm-slice="0 0 []"
                            ><span
                              style="
                                mso-spacerun: 'yes';
                                font-family: 微软雅黑;
                                font-weight: bold;
                                font-size: 12pt;
                                mso-font-kerning: 1pt;
                              "
                              ><font face="微软雅黑"
                                ><span leaf=""><br /></span></font></span
                          ></b>
                        </p>

                        <section
                          style="
                            text-align: left;
                            margin-top: 10px;
                            margin-bottom: 0px;
                            line-height: 1.5em;
                          "
                        >
                          <section
                            style="
                              box-sizing: border-box;
                              font-style: normal;
                              font-weight: 400;
                              font-size: 16px;
                              color: rgb(62, 62, 62);
                            "
                            data-pm-slice='6 5 ["para",{"tagName":"section","attributes":{"powered-by":"xiumi.us","style":"margin-bottom: 0px;margin-left: 0em;margin-right: 0em;","data-mpa-action-id":"mnffontc14ws"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"font-size: 16px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"text-align: left;margin-top: 10px;margin-bottom: 0px;line-height: 1.5em;"},"namespaceURI":"http://www.w3.org/1999/xhtml"},"para",{"tagName":"section","attributes":{"style":"margin-top: 10px;"},"namespaceURI":"http://www.w3.org/1999/xhtml"}]'
                          >
                            <section
                              style="
                                text-align: left;
                                margin-top: 10px;
                                margin-bottom: 0px;
                                line-height: 1.5em;
                              "
                            >
                              <section style="margin-top: 10px">
                                <section
                                  style="
                                    box-sizing: border-box;
                                    font-style: normal;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: rgb(62, 62, 62);
                                  "
                                  data-pm-slice="0 0 []"
                                >
                                  <section
                                    powered-by="xiumi.us"
                                    style="
                                      margin-bottom: 0px;
                                      margin-left: 0em;
                                      margin-right: 0em;
                                    "
                                    data-mpa-action-id="mnffontc14ws"
                                  >
                                    <section
                                      style="
                                        text-align: left;
                                        margin-top: 10px;
                                        margin-bottom: 0px;
                                        line-height: 1.5em;
                                      "
                                    >
                                      <section
                                        style="
                                          box-sizing: border-box;
                                          font-style: normal;
                                          font-weight: 400;
                                          font-size: 16px;
                                          color: rgb(62, 62, 62);
                                        "
                                      >
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><span
                                              style="
                                                mso-spacerun: 'yes';
                                                font-family: 微软雅黑;
                                                font-size: 10.5pt;
                                                mso-font-kerning: 1pt;
                                              "
                                              ><font face="微软雅黑"
                                                ><span leaf=""
                                                  ><span
                                                    textstyle=""
                                                    style="
                                                      font-size: 16px;
                                                      font-weight: normal;
                                                    "
                                                    >Biotoxin drugs superior to
                                                    first-generation ADCs
                                                    precisely target and
                                                    eliminate pathological
                                                    cells.</span
                                                  ></span
                                                ></font
                                              ></span
                                            ></b
                                          >
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <section
                                          style="text-align: center"
                                          nodeleaf=""
                                        >
                                          <img
                                            data-src="https://mmecoa.qpic.cn/mmecoa_png/HQa0QSLr0vITFicQ05PzdRWG7Rsvs9bpfMSyZNiaSxiaRkmsU4Via3tk9icXzkTQc3IHfzn3fjNeur4DSjCbFHOIVJGRty5AKS4iaOzTfW5pl7CicA/640?wx_fmt=png&amp;from=appmsg#imgIndex=19"
                                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                                            data-ratio="0.3253333333333333"
                                            data-s="300,640"
                                            data-type="png"
                                            data-w="750"
                                            style="
                                              width: 677px !important;
                                              height: auto !important;
                                            "
                                            data-croporisrc="https://www.healthcode.com/media/news/260509/cba-3.png"
                                            data-cropselx2="578"
                                            data-cropsely2="188"
                                            data-imgfileid="100005508"
                                            data-aistatus="1"
                                            data-original-style="width: 100%;"
                                            data-index="22"
                                            src="https://www.healthcode.com/media/news/260509/cba-3.png"
                                            _width="100%"
                                            alt="图片"
                                          />
                                        </section>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>

                                        <section
                                          powered-by="xiumi.us"
                                          style="
                                            margin-bottom: 0px;
                                            margin-left: 0em;
                                            margin-right: 0em;
                                          "
                                          data-mpa-action-id="mnffontc14ws"
                                        >
                                          <section style="font-size: 16px">
                                            <section style="font-size: 16px">
                                              <section
                                                style="
                                                  text-align: left;
                                                  margin-top: 10px;
                                                  margin-bottom: 0px;
                                                  line-height: 1.5em;
                                                "
                                              >
                                                <section
                                                  style="
                                                    box-sizing: border-box;
                                                    font-style: normal;
                                                    font-weight: 400;
                                                    font-size: 16px;
                                                    color: rgb(62, 62, 62);
                                                  "
                                                  data-pm-slice="0 0 []"
                                                >
                                                  <section
                                                    powered-by="xiumi.us"
                                                    style="
                                                      margin-bottom: 0px;
                                                      margin-left: 0em;
                                                      margin-right: 0em;
                                                    "
                                                    data-mpa-action-id="mnffontc14ws"
                                                  >
                                                    <section
                                                      style="
                                                        box-sizing: border-box;
                                                        font-style: normal;
                                                        font-weight: 400;
                                                        font-size: 16px;
                                                        color: rgb(62, 62, 62);
                                                      "
                                                    >
                                                      <section
                                                        style="
                                                          box-sizing: border-box;
                                                          font-style: normal;
                                                          font-weight: 400;
                                                          font-size: 16px;
                                                          color: rgb(
                                                            62,
                                                            62,
                                                            62
                                                          );
                                                        "
                                                      ></section>
                                                      <p
                                                        style=""
                                                        data-pm-slice="0 0 []"
                                                      >
                                                        <b
                                                          data-pm-slice="0 0 []"
                                                          ><b
                                                            data-pm-slice="0 0 []"
                                                            ><span
                                                              style="
                                                                mso-spacerun: 'yes';
                                                                font-family: 微软雅黑;
                                                                font-size: 10.5pt;
                                                                mso-font-kerning: 1pt;
                                                              "
                                                              ><font
                                                                face="微软雅黑"
                                                                ><span leaf=""
                                                                  ><span
                                                                    textstyle=""
                                                                    style="
                                                                      font-size: 16px;
                                                                      font-weight: normal;
                                                                    "
                                                                    >Multifunctional
                                                                    protein
                                                                    engineering
                                                                    and
                                                                    systematic
                                                                    integration
                                                                    enable the
                                                                    efficient
                                                                    research and
                                                                    development
                                                                    of complex
                                                                    biotherapeutics.</span
                                                                  ></span
                                                                ></font
                                                              ></span
                                                            ></b
                                                          ></b
                                                        >
                                                      </p>
                                                    </section>
                                                  </section>
                                                </section>
                                              </section>
                                            </section>
                                          </section>
                                        </section>
                                                                                <section
                                          style="text-align: center;margin:30px auto 20px auto;"
                                          nodeleaf=""
                                        >
                                          <img
                                            data-src="https://www.healthcode.com/media/news/260509/cba-d2p.png"
                                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                                            data-ratio="1.7770034843205575"
                                            data-s="300,640"
                                            data-type="png"
                                            data-w="574"
                                            style="
                                              width: 578px !important;
                                              height: auto !important;
                                              margin: 0 auto;
                                            "
                                            type="block"
                                            data-backw="574"
                                            data-backh="1020"
                                            data-imgfileid="100005509"
                                            data-aistatus="1"
                                            data-original-style="width:578px;height:1027px;"
                                            data-index="23"
                                            src="https://www.healthcode.com/media/news/260509/cba-d2p.png"
                                            _width="578px"
                                            alt="图片"
                                          />
                                        </section>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                        <p style="" data-pm-slice="0 0 []">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span
                                                style="
                                                  mso-spacerun: 'yes';
                                                  font-family: 微软雅黑;
                                                  font-size: 10.5pt;
                                                  mso-font-kerning: 1pt;
                                                "
                                                ><font face="微软雅黑"
                                                  ><span leaf=""
                                                    ><br /></span></font></span></b
                                          ></b>
                                        </p>
                                      
                                        <p style="text-align: center">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span leaf=""
                                                ><span
                                                  textstyle=""
                                                  style="
                                                    font-size: 20px;
                                                    font-weight: bold;
                                                  "
                                                  >Leveraging world-class
                                                  next-gen
                                                  biomanufacturing</span
                                                ></span
                                              ></b
                                            ></b
                                          >
                                        </p>
                                        <p style="text-align: center">
                                          <b data-pm-slice="0 0 []"
                                            ><b data-pm-slice="0 0 []"
                                              ><span leaf=""
                                                ><span
                                                  textstyle=""
                                                  style="
                                                    font-size: 20px;
                                                    font-weight: bold;
                                                  "
                                                  >Kangma fuels global medical
                                                  disruption with Chinese
                                                  wisdom.</span
                                                ></span
                                              ></b
                                            ></b
                                          >
                                        </p>
                                      </section>
                                    </section>
                                  </section>
                                </section>
                              </section>
                            </section>
                            <p style="line-height: 2em">
                              <b data-pm-slice="0 0 []"
                                ><span leaf=""><br /></span
                              ></b>
                            </p>
                          </section>
                        </section>
                        <section style="text-align: center" nodeleaf="">
                          <img
                            data-src="https://www.healthcode.com/media/news/260509/cba-17EN.png"
                            class="rich_pages wxw-img js_img_placeholder wx_img_placeholder"
                            data-ratio="1.7770034843205575"
                            data-s="300,640"
                            data-type="png"
                            data-w="574"
                            style="
                              aspect-ratio: calc(0.562745) / 1;
                              width: 578px !important;
                              height: auto !important;
                              margin: 0 auto;
                            "
                            type="block"
                            data-backw="574"
                            data-backh="1020"
                            data-imgfileid="100005509"
                            data-aistatus="1"
                            data-original-style="width:578px;height:1027px;"
                            data-index="23"
                            src="https://www.healthcode.com/media/news/260509/cba-17EN.png"
                            _width="578px"
                            alt="图片"
                          />
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </div>
        </div>
        <div
          id="js_tags_preview_toast"
          class="article-tag__error-tips"
          style="display: none"
        >
          预览时标签不可点
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const currentLang = computed(() => locale.value);

const switchLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem("locale", lang);
};

watch(locale, (newLocale) => {
  console.log(`语言已切换到: ${newLocale}`);
});

console.log("AI新闻页面加载完成");
</script>

<style scoped>
p {
  font-size: 16px;
}
.ai-page-container {
  width: 100%;
  max-width: 677px;
  margin: 9rem auto 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: #333;
  line-height: 1.6;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 40px;
  padding:20px;
  box-sizing: border-box;
}
.h-titile {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
